import {
  RecordVoiceOverOutlined,
  AccessTimeOutlined,
  WindowOutlined,
  HomeRepairServiceOutlined,
  ContentPasteOutlined,
  SettingsOutlined,
  AccountBalance,
  PeopleOutlineOutlined,
  CalendarTodayOutlined,
  PersonOutlineOutlined,
  HeadsetMicOutlined,
  NotificationsNoneOutlined,
  StarBorderOutlined,
  PaymentOutlined,
} from "@mui/icons-material"
import { HiOutlineChartPie } from "react-icons/hi";

export function getPaths() {
  return [
    {
      path: "/bookings-calendar",
      value: "Расписание",
      Icon: CalendarTodayOutlined,
      permission: false,
    },
    { 
      path: "/bookings",
      value: "Записи",
      Icon: ContentPasteOutlined,
      permission: null,
    },
    // {
    //   path: "/notifications",
    //   value: "Уведомления",
    //   Icon: NotificationsNoneOutlined,
    //   permission: false,
    // },
    {
      path: "/customers",
      value: "Клиенты",
      Icon: RecordVoiceOverOutlined,
      permission: null,
    },
    {
      path: "/masters",
      value: "Сотрудники",
      Icon: PeopleOutlineOutlined,
      permission: null,
    },
    {
      path: "/categories",
      value: "Категории услуг",
      Icon: WindowOutlined,
      permission: null,
    },
    {
      path: "/services",
      value: "Услуги",
      Icon: HomeRepairServiceOutlined,
      permission: null,
    },
    // {
    //   path: "/analytics",
    //   value: "Аналитика",
    //   Icon: HiOutlineChartPie,
    //   permission: null,
    // },
    {
      path: "/finance",
      value: "Финансы",
      Icon: AccountBalance,
      permission: null,
      hasSubmenu: true,
      submenu: [
        {
          path: "/finance/operations",
          value: "Финансовые операции",
          Icon: PaymentOutlined,
        },
        {
          path: "/finance/salary",
          value: "Расчет зарплаты",
          Icon: PeopleOutlineOutlined,
        }
      ]
    },
    {
      path: "/directories",
      value: "Справочники",
      Icon: ContentPasteOutlined,
      permission: null,
      hasSubmenu: true,
      submenu: [
        {
          path: "/directories/counterparties",
          value: "Контрагенты",
          Icon: PersonOutlineOutlined,
        },
        {
          path: "/directories/items",
          value: "Статья движения",
          Icon: HomeRepairServiceOutlined,
        },
        {
          path: "/directories/accounts",
          value: "Счета и кассы",
          Icon: AccountBalance,
        }
      ]
    },
    {
      path: "/reviews",
      value: "Отзывы",
      Icon: StarBorderOutlined,
      permission: null,
    },

    {
      path: "/feedback",
      value: "Обратная связь",
      Icon: HeadsetMicOutlined,
      permission: null,
    },

    {
      path: "/settings",
      value: "Настройки",
      Icon: SettingsOutlined,
      permission: null,
    },
    // {
    //   path:'/worktime',
    //   value: "Рабочее время",
    //   Icon: AccessTimeOutlined,
    //   permission: null,
    // }
    //  {
    //   path: "/clientConfigs",
    //   value: "Потверждение клиента",
    //   Icon: SettingsOutlined,
    //   permission: null,
    // },

    // {
    //   path: "/profile",
    //   value: "Профиль",
    //   Icon: PersonOutlineOutlined,
    //   permission: null,
    // },
    // {
    //   path: "/templates",
    //   value: "Шаблоны",
    //   Icon: PersonOutlineOutlined,
    //   permission: null,
    // },
    // {
    //   path: "/profile",
    //   value: "Профиль",
    //   Icon: PersonOutlineOutlined,
    //   permission: null,
    // },
    // {
    //   path: "/transactions",
    //   value: "Транзакции",
    //   Icon: AccountBalance,
    //   permission: null,
    // },
  ]
}
